module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Create Project","introduction":["Projects group Forms and App Users together to make them easier to organize and manage, both on this website and on your data collection device."]}}')
  delete Component.options._Ctor
}
